namespace Portico.Services {

    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    import models = Portico.Models;
  
    @Service('app', 'apiInterceptor')
    @Inject('$rootScope', '$q', '$injector')
    export class ApiInterceptor {
        private httpUnauthorized = 401;  // No bearer token
        private httpPreconditionFailed = 412;  // session missing
        private httpForbidden = 403;  // doesn't have the feature to make the call
        private porticoEvents: Portico.Services.IPorticoEvents;

        constructor(
            private $rootScope: ng.IRootScopeService,
            private $q: ng.IQService,
            private $injector: ng.auto.IInjectorService
        ) {
            this.porticoEvents = this.$injector.get("porticoEvents");
        }

        public responseError = (response: any) => {
            if (response.status === this.httpUnauthorized || response.status === this.httpPreconditionFailed || response.status == this.httpForbidden) {
                this.porticoEvents.unauthorizedEvent();
            }
        };
      
        public requestError = (rejection: any) => {
            this.porticoEvents.loggedOutEvent();
            return this.$q.reject(rejection);
        };
    }
}